let Test = require('@/mixins/Forms/2022/NRCA_LTI_04_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            functional_test: {
                name: `B. Functional Testing Method 1: Illuminance Measurement (NA7.6.3.2)`,
                steps: {
                    step_1: {
                        name: `Step 1: Select one location for illuminance measurement. The preferred measurement location is not in a skylit or primary sidelit area so that the illuminance meter is not in direct view of window or skylight. If his is not possible, perform the test at a time and location at which daylight illuminance provides less than half of the design illuminance.`,
                        id:`1`,
                        code_reference:`NA7.6.3.2.1, Method 1(a)`,
                        rows: {
                            row_1: {
                                id: `1.1`,
                                type: 'Float',
                                question: `Enter the design illuminance value in footcandles (fc)`,
                                code_reference:null,
                                spaces: []
                            }
                        }
                    },
                    step_2: {
                        name: `Step 2: Full output test`,
                        id:`2`,
                        code_reference:`NA7.6.3.2, Method 1(b)`,
                        rows: {
                            row_1: {
                                id: `2.1`,
                                type: 'Text',
                                text: `Using the manual switches/dimmers, set the lighting system to full output. For a lighting system that has been task tuned, override the controls to allow the lighting  system to go to full output. The lighting in areas with photo controls or occupant/vacancy sensors may be at less than full output or may be off`,
                                code_reference:`NA7.6.3.2.1, Method 1(b)1`,
                            },
                            row_2: {
                                id: `2.2`,
                                type: 'Float',
                                question: `Measure the illuminance at the selected location and enter the value in footcandles (fc).`,
                                code_reference:`NA7.6.3.2.1, Method 1(b)2`,
                                spaces: []
                            },
                            row_3: {
                                id: `2.3`,
                                type: 'Text',
                                text: `Simulate a demand response condition using the demand responsive control.`,
                                code_reference:`NA7.6.3.2.1, Method 1(b)3`,
                            },
                            row_4: {
                                id: `2.4`,
                                type: 'Float',
                                question: `Measure the illuminance at the selected location with the electric lighting system in the demand response condition and enter the value in footcandles (fc).`,
                                code_reference:`NA7.6.3.2.1, Method 1(b)4`,
                                spaces: []
                            },
                            row_5: {
                                id: `2.5`,
                                type: 'Percentage',
                                question: `Calculate the percent reduction in illuminance from the full output condition to the demand response condition to the demand response condition and enter the value in %. Percent reduction = [(Step 2.2 - Step 2.4) / Step 2.2] x 100%`,
                                code_reference:null,
                                spaces: []
                            },
                            row_6: {
                                id: `2.6`,
                                type: 'Float',
                                question: `Enter the area of the controlled space in square feet (ft2)`,
                                code_reference:null,
                                spaces: []
                            },
                            row_7: {
                                id: `2.7`,
                                type: 'Percentage',
                                question: `Calculate the area-weighted average reduction in illuminance from the full output condition to the demand response condition for the building using the given formula and enter the value in %.`,
                                code_reference:`NA7.6.3.2.1, Method 1(b)5`,
                                answer: 0,
                                merge_cells: true,
                            },
                            row_8: {
                                id: `2.8`,
                                type: 'BooleanResult',
                                question: `The area-weighted average reduction (Step 2.7) is at least 15%. ()`,
                                code_reference:`NA7.6.3.2.1, Method 1(b)5, Section 110.12(c)`,
                                answer: false,
                                merge_cells: true,
                            },
                        }
                    },
                    step_3: {
                        name: `Step 3: Minimum output test`,
                        id:`3`,
                        code_reference:`NA7.6.3.2.1, Method 1(c)1i`,
                        rows: {
                            row_1: {
                                id: `3.1`,
                                type: 'Text',
                                text: `Using the manual switches/dimmers in each space, set the lighting system to minimum output (but not off). The lighting in areas with photo controls or occupant/vacancy sensors may be at more than minimum output or may be off.`,
                                code_reference:`NA7.6.3.2, Method 1(c)1`,
                            },
                            row_2: {
                                id: `3.2`,
                                type: 'Float',
                                question: `Measure the illuminance at the selected location and enter the value in footcandles (fc). `,
                                code_reference:`NA7.6.3.2.1, Method 1(c)1ii`,
                                spaces: []
                            },
                            row_3: {
                                id: `3.3`,
                                type: 'Text',
                                text: `Simulate a demand response condition using the demand responsive control.`,
                                code_reference:`NA7.6.3.2.1, Method 1(c)2i`,
                            },
                            row_4: {
                                id: `3.4`,
                                type: 'Float',
                                question: `Measure the illuminance at the selected location with the electric lighting system in the demand response condition and enter the value in footcandles (fc).`,
                                code_reference:`NA7.6.3.2.1, Method 1(c)2ii`,
                                spaces: []
                            },
                            row_5: {
                                id: `3.5`,
                                type: 'BooleanResult',
                                question: `The illuminance in the demand respond condition (Step 3.4) is not less than the illuminance in the minimum output condition (Step 3.2). (Step 3.4 >= Step 3.2). Enter yes (<b>Y</b>) or no (<b>N</b>).<br><small>Exception: In daylit spaces, the illuminance in the demand response condition (Step 3.4) may reduce below the illuminance in the minimum output condition. </small>`,
                                code_reference:`NA7.6.3.2.1, Method 1(c)3i`,
                                spaces: []
                            },
                        }
                    },
                },
                result: false,
                comments: '',
                spaces: [],
            },
        }
    },

    mounted() {
        if (this.data == null) {
            this.addSpace();
        }
    },

    methods: {

        functionalTestEvaluation() {

            this.form.functional_test.result = true;

            var steps = this.form.functional_test.steps;

            var s1Questions = steps.step_1.rows;
            var s2Questions = steps.step_2.rows;
            var s3Questions = steps.step_3.rows;

            var row_2_7_top = 0;
            var row_2_7_bottom = 0;

            _.each(this.form.functional_test.spaces, (space, index) => {

                // Line F =  [(Line C - Line E) / Line C] x 100%)
                var row_2_2 = s2Questions.row_2.spaces[index].answer;
                var row_2_4 = s2Questions.row_4.spaces[index].answer;
                var row_2_5 = ((row_2_2 - row_2_4) / row_2_2);
                if(!this.isValidNumber(row_2_5)){
                    row_2_5 = 0
                }
                s2Questions.row_5.spaces[index].answer = row_2_5

                // Line H
                var row_2_6 = s2Questions.row_6.spaces[index].answer;

                row_2_7_top += (row_2_5 * row_2_6)
                row_2_7_bottom += row_2_6;

                // Line J
                var row_1_1 = s1Questions.row_1.spaces[index].answer;
                // var row_J = s2Questions.row_9.spaces[index].answer = (row_2_4 / row_1_1) >= .5

                // Line O
                var row_3_3 = s3Questions.row_2.spaces[index].answer;
                var row_3_5 = s3Questions.row_4.spaces[index].answer;

                // 50% of Line A
                var _50PercentOfRow2_1 = (.5 * row_1_1)

                // Changes made by Mario Martinez
                var resultOne = (row_3_3 < _50PercentOfRow2_1 && row_3_5 < row_3_3);
                var resultTwo = (row_3_3 >= _50PercentOfRow2_1 && row_3_5 < _50PercentOfRow2_1);
                var resultThree = (row_3_5 <= row_1_1);
                var resultFour = (row_3_3 > 0);

                var row_O = s3Questions.row_5.spaces[index].answer = (!resultOne && !resultTwo && resultThree && resultFour);

                if (/*row_J == false || */row_O == false) {
                    this.form.functional_test.result = false;
                }
            })

            // Line H
            var result = (row_2_7_top / row_2_7_bottom);
            var row_2_7 = s2Questions.row_7.answer = this.isValidNumber(result) ? result : 0;

            // Line I
            var row_2_8 = s2Questions.row_8.answer = (row_2_7 >= .15);

            if (row_2_8 == false) {
                this.form.functional_test.result = false;
            }
        },

        loadFormData() {
            if (!this.data) return;

            _.each(this.data.construction_inspection.rows, (question, i) => {
                this.form.construction_inspection.rows[i].answer = question.answer;
            })

            _.each(this.data.functional_test.spaces, space => {
                this.updateQuestionSpaces(space);
            })

            _.each(this.data.functional_test.steps, (step, i) => {
                _.each(step.rows, (question, j) => {
                    _.each(this.data.functional_test.spaces, (space, k) => {
                        if (!this.isText(this.form.functional_test.steps[i].rows[j])) {
                            if (question.hasOwnProperty('merge_cells')) {
                                this.form.functional_test.steps[i].rows[j].answer = question.answer;
                            } else {
                                this.form.functional_test.steps[i].rows[j].spaces[k].answer = question.spaces[k].answer
                            }
                        }
                    })
                })
            })

            this.form.comments = this.data.comments;
        },

        removeSpace() {
            if (this.canRemoveSpace) {
                var space = this.form.functional_test.spaces[this.form.functional_test.spaces.length - 1];
                Alert.confirmation(`All data with from Space ${space.name} will be removed.<br>Do you want to continue?`).then(response => {
                    this.form.functional_test.spaces.pop();
                    this.removeSpaceFromQuestions();
                }).catch(() => {
                })
            }
        },

        removeSpaceFromQuestions() {
            _.each(this.form.functional_test.steps, step => {
                _.each(step.rows, question => {
                    if (!this.isText(question)) {
                        question.spaces.pop()
                    }
                })
            })
        },

        addSpace() {
            this.updateQuestionSpaces({
                id: (this.form.functional_test.spaces.length + 1),
                name: `#${this.form.functional_test.spaces.length + 1}`
            });
        },

        updateQuestionSpaces(space) {
            this.form.functional_test.spaces.push(space);
            _.each(this.form.functional_test.steps, step => {
                _.each(step.rows, question => {
                    if (question.hasOwnProperty('merge_cells')) {
                        question.answer = this.getDefaultValueForDinamicQuestion(question);
                    } else if (question.type != 'Text') {
                        question.spaces.push({
                            id: space.id,
                            name: space.name,
                            answer: this.getDefaultValueForDinamicQuestion(question),
                        });
                    }
                })
            })
        },

    },

    computed: {

        rowColspan() {
            return this.form.functional_test.spaces.length;
        },

        canRemoveSpace() {
            return this.testIsReady ? (this.form.functional_test.spaces.length > 1) : false;
        },
    }

}
